import { useState, useEffect } from 'react';
import { Box, Flex, IconButton, Button, Switch } from '@chakra-ui/react';
import { MdDelete, MdSearch, MdEdit } from 'react-icons/md';

import Page from '../components/common/Page';
import { ApiCommand } from '../lib/Api';
import useToastNotification from '../lib/hooks/useToastNotification';
import StrongTable from '../components/common/StrongTable';
import StrongPagination from '../components/common/StrongPagination';
import useApi from '../lib/hooks/useApi';
import urlConstants from '../lib/constants/url.constants';
import StrongInput from '../components/common/StrongInput';
import ThumbnailPreview from '../components/common/ThumbnailPreview';
import EditEquipmentModal from '../components/equipments/EditEquipmentModal';



const {
  getSectionstitle: getSectionsTitleUrl,
  createEquipment: createEquipmentUrl,
  getEquipments: getEquipmentsUrl,
  editEquipment: editEquipmentUrl,
  deleteEquipment: deleteEquipmentUrl,
} = urlConstants.equipments;

const Equipments = () => {
  const [equipments, setEquipments] = useState<Equipment[]>([]);
  const [programstitle, setProgramsTitle] = useState<ProgramTitle[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [totalCount, setTotalCount] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(5);
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  const [selectedEquipment, setSelectedEquipment] = useState<Equipment>();

  const showToast = useToastNotification();

  const { loading: isGetEquipmentsLoading, sendRequest: getEquipments } =
    useApi<GetEquipmentsResopnse>();
  const { loading: isGetProgramTitlesLoading, sendRequest: getProgramTitles } =
    useApi<ProgramTitle[]>();
  const { loading: isCreateEquipmentLoading, sendRequest: createEquipment } =
    useApi<any>();
  const { loading: isEditEquipmentLoading, sendRequest: editEquipment } =
    useApi<any>();
  const { loading: isDeleteEquipmentLoading, sendRequest: deleteEquipment } =
    useApi<any>();

  
  const EUIPMENT_COLUMNS = [
  {
    key: 'title',
    label: 'Title',
  },
  {
    key: 'thumbnail',
    label: 'Thumbnail',
    render: (value: string) => <ThumbnailPreview imageUrl={value} />,
  },
  {
    key: 'description',
    label: 'Description',
  },
  {
    key: 'link',
    label: 'Link',
  },
  {
      key: 'status',
      label: 'Status',
      render: (value: any, row: any) => (
        <Switch
          colorScheme='primary'
          isChecked={value}
          onChange={() => handleStatusToggle(row.id, value)}
        />
      ),
    },
  ];
  
  const fetchEquipments = () => {
    getEquipments({
      callback: (data: GetEquipmentsResopnse | null, error: string | null) => {
        if (error) {
          showToast({
            title: 'Failed',
            description: error,
            status: 'error',
          });
          return;
        }
        if (!data) return null;
        console.log('Equipments list response:', data.equipments);
        setEquipments(data.equipments);
        setTotalPages(data.pagination.totalPages);
        setTotalCount(data.pagination.totalCount);
      },
      command: ApiCommand.GET,
      url: getEquipmentsUrl,
      options: {
        page: currentPage,
        limit: pageSize,
      },
    });
  };
  const fetchProgramInfoTitles = () => {
    getProgramTitles({
      callback: (data: ProgramTitle[] | null, error: string | null) => {
        if (error) {
          showToast({
            title: 'Failed',
            description: error,
            status: 'error',
          });
          return;
        }
        if (!data) return null;
        setProgramsTitle(data);
      },
      command: ApiCommand.GET,
      url: getSectionsTitleUrl,
    });
  };

  useEffect(() => {
    fetchEquipments();
    fetchProgramInfoTitles();
  }, [currentPage, pageSize]);

  const handlePageSizeChange = (size: number) => {
    setPageSize(size);
    setCurrentPage(1);
  };

  const onSaveEquipment = (
    title: string,
    description: string,
    link: string,
    thumbnail: File | null,
    selectedProgramsInfo: String[],
    type: string,
  ) => {
    const formData = new FormData();
    formData.append('title', title);
    formData.append('description', description);
    formData.append('link', link);
    formData.append('type', type || 'exercise-item');
    formData.append('programinfos', JSON.stringify(selectedProgramsInfo));
    if (thumbnail) {
      formData.append('thumbnail', thumbnail);
    }
    if (selectedEquipment) {
      formData.append('equipmentId', selectedEquipment?.id || '');
      editEquipment({
        callback: (_data, error: string | null) => {
          if (error) {
            showToast({
              title: 'Failed',
              description: error,
              status: 'error',
            });
            return;
          }
          showToast({
            title: 'Success',
            description: 'Equipment updated successfully',
            status: 'success',
          });
          setIsOpenModal(false);
          fetchEquipments();
        },
        command: ApiCommand.PUT,
        url: editEquipmentUrl,
        options: formData,
      });
    } else {
      createEquipment({
        callback: (_data, error: string | null) => {
          if (error) {
            showToast({
              title: 'Failed',
              description: error,
              status: 'error',
            });
            return;
          }
          showToast({
            title: 'Success',
            description: 'Equipment created successfully',
            status: 'success',
          });
          setIsOpenModal(false);
          fetchEquipments();
        },
        command: ApiCommand.POST,
        url: createEquipmentUrl,
        options: formData,
      });
    }
  };

  const handleStatusToggle = (equipmentId: string,    
  currentStatus: boolean) => {                        
    const formData = new FormData();                
    formData.append('equipmentId', equipmentId);      
    formData.append('status', String(!currentStatus));
    editEquipment({                                 
      callback: (_data, error: string | null) => {
        if (error) {                                  
          showToast({ title: 'Failed', description:error, status: 'error' });                          
          return; 
        }                                           
        showToast({ title: 'Success', description:
  'Status updated', status: 'success' });             
        fetchEquipments();
      },                                              
      command: ApiCommand.PUT,
      url: editEquipmentUrl,                        
      options: formData,
    });
  };

  const onDeleteEquipment = (equipmentId: string) => {
    deleteEquipment({
      callback: (_data, error: string | null) => {
        if (error) {
          showToast({
            title: 'Failed',
            description: error,
            status: 'error',
          });
          return;
        }
        showToast({
          title: 'Success',
          description: 'Equipment deleted successfully',
          status: 'success',
        });
        fetchEquipments();
      },
      command: ApiCommand.DELETE,
      url: deleteEquipmentUrl,
      options: {
        equipmentId,
      },
    });
  };

  const onEditEquipment = (equipmentId: string) => {
    setSelectedEquipment(equipments.find(({ id }) => id === equipmentId));
    setIsOpenModal(true);
  };

  return (
    <Page>
      <Flex
        justifyContent='space-between'
        alignItems='center'
        mb={6}
        gap={4}
        flexWrap='wrap'
      >
        <Box flex='1' maxW='400px'>
          <StrongInput
            placeholder='Search'
            rightIcon={<MdSearch color='gray.500' />}
          />
        </Box>
        <Button
          colorScheme='primary'
          px={6}
          py={4}
          borderRadius='md'
          fontWeight='bold'
          _hover={{ bg: 'primary.300' }}
          onClick={() => {
            setSelectedEquipment(undefined);
            setIsOpenModal(true);
          }}
        >
          Create Equipment
        </Button>
      </Flex>

      <Flex flexDirection='column' height='full' justifyContent='space-between'>
        <Box
          backgroundColor='white'
          borderRadius='lg'
          height='calc(100vh - 275px)'
        >
          <StrongTable
            columns={EUIPMENT_COLUMNS}
            data={equipments}
            loading={isGetEquipmentsLoading}
            actions={(row) => (
              <>
                <IconButton
                  aria-label='Edit Equipment'
                  icon={<MdEdit />}
                  variant='outline'
                  colorScheme='primary'
                  size='sm'
                  marginRight={4}
                  onClick={() => onEditEquipment(row.id)}
                />
                <IconButton
                  aria-label='Delete Equipment'
                  icon={<MdDelete />}
                  variant='outline'
                  colorScheme='red'
                  size='sm'
                  onClick={() => onDeleteEquipment(row.id)}
                />
              </>
            )}
          />
        </Box>

        <StrongPagination
          currentPage={currentPage}
          totalPages={totalPages}
          totalCount={totalCount}
          pageSize={pageSize}
          onPageChange={setCurrentPage}
          onPageSizeChange={handlePageSizeChange}
        />
      </Flex>

      <EditEquipmentModal
        isOpen={isOpenModal}
        onClose={() => setIsOpenModal(false)}
        onSubmit={onSaveEquipment}
        programstitle={programstitle}
        selectedEquipment={selectedEquipment}
      />
    </Page>
  );
};

export default Equipments;
